( function () {
   
    'use strict';

    ( function ( $ ) {
        
        if($('.hero-slider').length > 0){
            $(".featured-news-btn").hover(function(e){
                e.preventDefault();
                $(".hero-featured-news-detail").addClass("open");
                $(".hero-featured-news").addClass("open");
            });
            
            $(".hero-banner-slider").hover(function(e){
                e.preventDefault();
                $(".hero-featured-news-detail").removeClass("open");
                $(".hero-featured-news").removeClass("open");
            });
        }
        if($('.hero-slider').length < 767){
            $(".hero-featured-news .featured-news-btn").click(function(e){
                e.preventDefault();
                $(".hero-featured-news-detail").toggleClass("open");
                $(".hero-featured-news").toggleClass("open");
               
                return false;
            });
        }
        $('.banner-slider').slick({
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:true,
            autoplaySpeed: 11000,
            speed: 1000,
            fade: true,
            arrows:false,
            responsive: [
                {
                    breakpoint: 1260,
                    settings: {
                        slidesToShow:1,
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow:1,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow:1,
                        autoplay:false,
                    },
                }
            ]
        });
    } )(jQuery);
} )();

